import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { setAdminUsersFilterGroupOption, usersAdminFilterGroupSelector } from 'src/features'

const filterOptions = ['producers', 'offsetters', 'validators', 'certifiers', 'prime calculator']

const FilterUsersByGroup: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const selectedGroup = useAppSelector(usersAdminFilterGroupSelector)
  const { width } = useWindowSize()
  const isMobile = width <= 800

  const handleChange = (value: string) => {
    dispatch(setAdminUsersFilterGroupOption(value))
  }

  return (
    <Select
      value={selectedGroup}
      onChange={handleChange}
      style={{ width: isMobile ? '100%' : '90%' }}
      className={isMobile && 'mb-2'}
    >
      <Select.Option value={'ALL'}>{t(`Validate.Groups`)}</Select.Option>
      {filterOptions.map((option, idx) => (
        <Select.Option value={option} key={idx}>{t(`${option}`)}</Select.Option>
      ))}
    </ Select>
  )
}

export default FilterUsersByGroup
